import { logger } from 'helpers'
var menu = {}
try {
  menu = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/menu')
} catch (e) {
  logger.debug('No project-specific config for menu')
}
module.exports = {
  items: menu
}



// WEBPACK FOOTER //
// ./src/config/menu.js